import { useContext } from 'react';

import Card3DBackMemo from '@/components/game/3d/object/card/Card3DBackMemo';
import { GameContext, ViewContext } from '@/state/contexts';

const HandBuilder = ({
	playerId,
	seasonalCards,
	summitCards,
	textureSS,
	textureFW,
	textureSummit,
}) => {
	const {	
		isTutorial,
		stepTutorial,
		setStepTutorial
	}: any = useContext(GameContext);

	const { 
		setShowHandModal,
		currentTickerTimer,
		setCurrentTickerIndex }: any = useContext(ViewContext);

	function displayHand() {
		if(isTutorial && stepTutorial === 21){
			setStepTutorial((prev) => prev + 1);
			clearTimeout(currentTickerTimer);
			setCurrentTickerIndex((prev) => prev + 1);
		}
		if(isTutorial && stepTutorial === 25){
			setStepTutorial((prev) => prev + 1);
			clearTimeout(currentTickerTimer);
			setCurrentTickerIndex((prev) => prev + 1);
		}
		setShowHandModal(true);
	}

	if (
		(seasonalCards == null || seasonalCards.length === 0) &&
		(summitCards == null || summitCards.length === 0)
	) {
		return;
	}

	const handArray: any = [];
	let idBuffer = seasonalCards.length;

	const cardHeight = 18.5;

	for (let z = seasonalCards.length - 1; z >= 0; z--) {
		const cardId = seasonalCards[z];
		let texture = textureSS;
		if (cardId > 100) {
			texture = textureFW;
		}

		handArray.push(
			<group
				key={`hand_group_${z}_${playerId}`}
				rotation={[1.5708, 0, 0]}
				position={[-10 + 2.5 * z, cardHeight, 17]}
				scale={[0.75, 0.75, 0.75]}
			>
				<Card3DBackMemo
					key={`hand_${z}_${playerId}`}
					texture={texture}
					viewCardModal={displayHand}
				/>
			</group>
		);
	}

	let offset = handArray.length;

	for (let z = summitCards.length - 1; z >= 0; z--) {
		handArray.push(
			<group
				key={`hand_group__${z + idBuffer}_${playerId}`}
				rotation={[1.5708, 0, 0]}
				position={[-10 + 2.5 * (z + offset), cardHeight, 17]}
				scale={[0.75, 0.75, 0.75]}
			>
				<Card3DBackMemo
					key={`hand__${z + idBuffer}_${playerId}`}
					texture={textureSummit}
					viewCardModal={displayHand}
				/>
			</group>
		);
	}

	return <>{handArray}</>;
};

export default HandBuilder;
